<template>
	<div>
		<template v-if="!renderCell">
			<div :class="{readonly:readonly}">
				<el-cascader v-if="cascader" :props="{ checkStrictly: checkStrictly ,multiple:multiple}"
					v-model="selectvalue" :size="size" :options="options" :placeholder="placeholder"
					:disabled="disabled" :collapse-tags="collapseTags" clearable filterable :show-all-levels="showAllLevels" >
					<template slot-scope="{ node, data }">
						<span>{{ data.label }}</span>
						<span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
						<span v-if="node.isLeaf && data.alias">
							<el-tag size="mini" style="margin-left: 10px;">{{ data.alias }}</el-tag>
						</span>
					</template>
				</el-cascader>

				<el-checkbox-group v-else-if="checkbox" v-model="selectvalue" :size="size" :disabled="disabled"
					clearable>
					<el-checkbox-button v-for="item in options" :key="item.value" :label="item.value">
						{{item.label}}
					</el-checkbox-button>
				</el-checkbox-group>


				<el-select v-else v-model="selectvalue" :size="size" :placeholder="placeholder" :disabled="disabled"
					clearable transfer filterable :multiple="(islist || multiple) && device=='pc'"
					:collapse-tags="collapseTags">
					<template v-if="!group">
						<el-option v-for="item in options" :key="item.label + item.value" :label="item.label"
							:value="item.value" v-show="!(!islist && item.enable==6)">

						</el-option>
					</template>
					<template v-else>
						<el-option-group v-for="group in options" :key="group.label" :label="group.label">
							<el-option v-for="item in group.options" :key="item.value" :label="item.label"
								:value="item.value" v-show="!(!islist && item.enable==6)">
							</el-option>
						</el-option-group>
					</template>
				</el-select>
			</div>
		</template>
		<template v-else>
			<span>{{textValue}}</span>
		</template>
	</div>
</template>

<style scoped>
	.readonly {
		pointer-events: none;
	}

	.readonly>* {
		pointer-events: none;
	}
</style>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			cascader: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			checkStrictly: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			showAllLevels: {
				type: Boolean,
				default: () => {
					return true
				}
			},
			group: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			checkbox: {
				type: Boolean,
				default: () => {
					return false
				}
			},
		},
		data() {
			return {
				ready: false,
				options: [],
				device: window.systemMethods.device(),
				selectvalue: this.value

			}
		},
		created() {

		},
		mounted() {
			
			if (this.multiple || this.checkbox || this.islist) {
				this.selectvalue = this.value ? this.value : []
				this.createMultipleValue()
			} else {
				this.selectvalue = this.value ? this.value : null
			}
			//console.log(this.options)
		},
		watch: {
			value(e) {
				if (this.multiple || this.checkbox || this.islist) {
					this.selectvalue = e ? e : []
					this.createMultipleValue()
				} else {
					this.selectvalue = e ? e : null
				}
			},
			selectvalue(e) {
				this.change(e)

			}
		},
		computed: {
			textValue() {
				//console.log(this.value,123123)
				let text = ''
				if (Array.isArray(this.value)) {					
					let options = []
					let arr = []
					options = this.options
					this.value.forEach((item) => {
						for (let i = 0; i < options.length; i++) {
							if (options[i].value == item) {
								arr.push(options[i].label)
								options = options[i].children ? options[i].children : []
								break
							}
						}

					})
					text = arr.join('/')
				} else {
					for (let i = 0; i < this.options.length; i++) {
						if (this.options[i].value == this.value) {
							text = this.options[i].label
							break
						}
					}
				}
				return text
			},


		},

		methods: {
			createMultipleValue(){
				if(!Array.isArray(this.selectvalue)){
					this.selectvalue = this.selectvalue.toString().split(',')
					this.selectvalue.forEach((item,index)=>{
						this.selectvalue[index] = parseInt(item)
					})
				}
			},
		}
	}
</script>
